module.exports = __webpack_public_path__ + "img/中国农业银行_logo.a5618fea.png";